'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[app/global-error]', error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#eaeaef',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          padding: 24,
        }}
      >
        <div
          style={{
            maxWidth: 460,
            textAlign: 'center',
            background: '#ffffff',
            padding: 40,
            borderRadius: 14,
            border: '1px solid rgba(0,0,0,0.06)',
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        >
          <span
            style={{
              color: '#b56147',
              fontSize: 11,
              letterSpacing: '0.22em',
              textTransform: 'uppercase',
              fontFamily: 'ui-monospace, monospace',
            }}
          >
            Application error
          </span>
          <h1 style={{ fontSize: 28, fontWeight: 500, margin: 0, lineHeight: 1.2 }}>
            We hit an unexpected snag.
          </h1>
          <p style={{ fontSize: 15, color: 'rgba(0,0,0,0.65)', margin: 0, lineHeight: 1.55 }}>
            The error has been logged. Try again in a moment.
          </p>
          <button
            onClick={reset}
            style={{
              background: '#b56147',
              color: '#fff',
              border: 'none',
              padding: '10px 18px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
              alignSelf: 'center',
            }}
          >
            Try again
          </button>
          {error.digest && (
            <span
              style={{
                fontSize: 11,
                color: 'rgba(0,0,0,0.4)',
                fontFamily: 'ui-monospace, monospace',
                marginTop: 4,
              }}
            >
              ref · {error.digest}
            </span>
          )}
        </div>
      </body>
    </html>
  );
}
